<template>
<div>
<div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
   </div>
   <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
   </div>
  <div style="height:300px;" v-if="fetch">
      <div class="mx-auto text-center pt-5">
        <h4 class="text-info mb-2">You are still in the free trial period.</h4>
          <!-- <form class="mx-auto text-center pt-5" v-if="plan=='Premium'" action="https://sandbox.payhere.lk/pay/o5278e4fa" method="get"><input name="submit" type="image" src="https://www.payhere.lk/downloads/images/pay_with_payhere.png" style="width:200px;" value="Buy Now"></form>
          <form class="mx-auto text-center pt-5" v-if="plan=='Free'" action="https://sandbox.payhere.lk/pay/oe731229a" method="get"><input name="submit" type="image" src="https://www.payhere.lk/downloads/images/pay_with_payhere.png" style="width:200px;" value="Buy Now"></form>
          <form class="mx-auto text-center pt-5" v-if="plan=='Starter'" action="https://sandbox.payhere.lk/pay/ocb71b540" method="get"><input name="submit" type="image" src="https://www.payhere.lk/downloads/images/pay_with_payhere.png" style="width:200px;" value="Buy Now"></form> -->
      </div>
     
  </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit"
import firebase from 'firebase/app';
export default {
   name: 'payment',
  
   data(){
    return{
       shops:[],
       shopcat:'',
       shoptype:'',
       plan:'',
       loading:false,
       loading1:false,
       fetch:false 
    }
   },
  methods:{
     backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    },
  },
   created(){
     this.backToTop()
     this.loading = true
     this.fetch = false
    //    db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
    //   .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id': doc.id,
    //       'plan': doc.data().plan,
    //       'shopcat' : doc.data().cat,
    //       'shoptype' : doc.data().shoptype,
    //       'curProducts':doc.data().curProducts,
    //       'date': doc.data().created
          
    //     }
    //     this.shops.push(data)
    //     this.shopcat = this.shops[0].shopcat
    //     this.shoptype = this.shops[0].shoptype
    //     this.plan = this.shops[0].plan
    //     console.log('date is', this.shops[0].date)
    //     console.log('date is', this.shops[0].date.toDate())
    //    this.loading = false
    //    this.fetch = true
    //   })
    // })
        this.loading = false
        this.fetch = true
    // db.collection('shops').doc('378CDDcbFbGnSumbcBgj').update({
    //     created: firebase.firestore.Timestamp.now()
    // })
   }
}
</script>

<style scoped>
@import url('~@/assets/admin/css/admin-loader.css');

</style>


// WEBPACK FOOTER //
// src/components/admin/Payment.vue